import { Box, IconButton, Typography, useTheme } from '@mui/material'
import React, { useMemo } from 'react'
import { formatDate, Icons } from '../../utils/utilities'
import { Link } from 'react-router-dom'
import { useDownloadStatusListStore } from '../../store/downloadstatuslistdialog.store'
import CustomTable from '../common/custom-table/CustomTable'


const StudentMaterialList = ( { docsCount, page, rowsPerPage, handleChangeRowsPerPage, handleChangePage, filteredMaterials } ) => {

    const { border } = useTheme()

    const DownloadStatusListStore = useDownloadStatusListStore()

    const downloadMaterial = async ( id, data ) => {
        await DownloadStatusListStore.downloadMaterial( id, data )
    }

    const columns = useMemo( () => {
        return [
            {
                field: "study_material_name",
                linkGetter: row => `/student/material/${row.study_material_id}`,
                renderCell: ( row ) => {
                    return (
                        <Box width="300px" display="flex" gap="10px" alignItems="center">
                            {Icons.default.Material} <Typography variant="subtitle2" >{row.study_material_name}</Typography>
                        </Box>
                    )
                }, name: "Material Name",
                align: "left",
                width: "200px",
                maxWidth: "300px",
                rowPadding: "5px 20px"
            },
            {
                field: "study_material_created_by",
                linkGetter: row => `/student/material/${row.study_material_id}`,
                name: "Created By",
                align: "left",
                width: "200px",
                maxWidth: "200px",
                rowPadding: "5px 20px"
            },
            {
                field: "department_name",
                linkGetter: row => `/student/material/${row.study_material_id}`,
                renderCell: ( row ) => `${row.institute} - ${row.department_name}`,
                name: "Institute & Department",
                align: "left",
                width: "200px",
                maxWidth: "200px",
                rowPadding: "5px 20px"
            },
            {
                field: "subject_name",
                linkGetter: row => `/student/material/${row.study_material_id}`,
                renderCell: ( row ) => `${row.subject_name?.trim()} - ${row.subject_code?.trim()}`,
                name: "Subject-Code",
                align: "left",
                width: "300px",
                maxWidth: "300px",
                rowPadding: "5px 20px",
                cellStyles: { textTransform: "capitalize" }
            },
            {
                field: "last_updated",
                linkGetter: row => `/student/material/${row.study_material_id}`,
                renderCell: ( row ) => ( <Box display="flex" gap="5px" alignItems="center">
                    <Box display="flex" alignItems="center" fontSize="18px" component="span">{Icons.default.Calendar}</Box>
                    <Typography component="span" fontSize="inherit">{formatDate( row.last_updated || row.study_material_published_date )}</Typography>
                </Box> ),
                name: "Last updated",
                align: "left",
                width: "200px",
                rowPadding: "5px 20px"
            },
            {
                field: "study_material_id",
                renderCell: ( row ) => {
                    return (
                        <IconButton size="small" onClick={() => downloadMaterial( row.study_material_id, row )}>
                            {Icons.default.DownloadIconOutlined}
                        </IconButton>
                    )
                }, name: "Action", align: "right", padding: "10px", rowPadding: "5px 20px"
            }
        ]

        // eslint-disable-next-line
    }, [] )


    return (
        <Box position="relative" borderRadius="5px" border={border[1]} flexGrow={1} overflow="hidden" display="flex" flexDirection="column" >
            <CustomTable dataIdKey="study_material_id" pageSize={50} columns={columns} data={filteredMaterials} />
        </Box>
    )
}

export default StudentMaterialList
